import React from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../../../../util/assets';
import Button from '../../../../../../../../../components/global/Button';

const propTypes = {
  productName: PropTypes.string,
  onRequestClose: PropTypes.func,
};

const RequiresPrintPackageAlert = ({ productName, onRequestClose }) => {
  return (
    <div className="d-flex flex-column align-items-center p-2">
      <img src={getAsset('/icon-package-3d.svg')} alt="" className="mb-2" />
      <h4 className="text-center mb-3">
        {productName} can only be purchased after adding a print package to your
        cart.
      </h4>
      <Button onClick={onRequestClose}>OK</Button>
    </div>
  );
};

RequiresPrintPackageAlert.propTypes = propTypes;

export default RequiresPrintPackageAlert;
